import React, { useEffect, useRef } from 'react'

import { useField } from '@unform/core'
import { RadioPesquisaSatisfacao } from 'src/componentes/radio-pesquisa-satisfacao'
import { sanitizeUtil } from 'src/componentes/utils'
import { v4 } from 'uuid'

import { PerguntaProps } from '../tipos'
import { Container, Conteudo, Enunciado, Erro } from './styles'

export const PerguntaLinear: React.FC<PerguntaProps> = ({
  pergunta,
  name,
  tipo
}) => {
  const inputRefs = useRef<HTMLInputElement[]>([])
  const dezAlternativas = pergunta.alternativas.length >= 10
  const { fieldName, registerField, defaultValue, error } = useField(name)

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRefs.current,
      getValue: (refs: HTMLInputElement[]) => {
        return refs.find(ref => ref.checked)?.value ?? ''
      },
      clearValue: (refs: HTMLInputElement[]) => {
        refs.forEach(ref => {
          ref.checked = false
        })
      },
      setValue: (refs: HTMLInputElement[], value: string) => {
        refs.forEach(ref => {
          if (value === ref.value) {
            ref.checked = true
          }
        })
      }
    })
  }, [fieldName, registerField])

  return (
    <Container id={pergunta.id} ComErro={!!error}>
      <Enunciado>
        <p
          dangerouslySetInnerHTML={{
            __html: sanitizeUtil(pergunta.texto.replaceAll('<p></p>', '<br />'))
          }}
        />
      </Enunciado>
      <Conteudo>
        {pergunta.alternativas.map((item, index) => (
          <RadioPesquisaSatisfacao
            ref={ref => {
              if (ref) {
                inputRefs.current[index] = ref as HTMLInputElement
              }
            }}
            key={item.id}
            id={`${v4()}`}
            value={item.id}
            texto={item.texto}
            name={fieldName}
            defaultChecked={defaultValue === item.id}
            dezAlternativas={dezAlternativas}
            tipoPesquisa={tipo}
          />
        ))}
      </Conteudo>
      <Erro id={`erro-${pergunta.id}`}>{error}</Erro>
    </Container>
  )
}
